<template>

    <div class="mb-10 draggable bg-white rounded">
        <!-- Task Header. -->
        <div class="flex items-center mb-px">
            <div class="w-6 flex-shrink-0" v-if="editable">
                <i class="fa fa-bars text-sm text-gray-400 hover:text-gray-500 cursor-move handle"></i>
            </div>
            <div class="w-12">
                <input
                    :placeholder="task.defaultReference"
                    class="text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    type="text"
                    v-model="task.reference"
                    @input="update"
                    @change="inspectionTestPlan.addSnapshot()"
                    v-if="editable"
                >
                <div v-else class="text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10" v-text="task.reference"></div>
            </div>
            <div class="flex-1 ml-4">
                <input
                    placeholder="Untitled task..."
                    class="text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    type="text"
                    ref="name"
                    v-model="task.name"
                    @input="update"
                    @change="inspectionTestPlan.addSnapshot()"
                    v-if="editable"
                >
                <div v-else class="text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10" v-text="task.name"></div>
            </div>
            <div class="w-6 flex-shrink-0 ml-2" v-if="editable">
                <ui-dropdown menu-class="p-3 w-48">
                    <template #default="{ toggle }">
                        <button @click="toggle"
                                class="text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative p-1 rounded">
                            <i class="fa fa-ellipsis-h"></i>
                        </button>
                    </template>

                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-copy" @click="duplicateTask(); close()">Duplicate
                        </ui-dropdown-item>
                        <ui-dropdown-item icon="fas fa-trash" danger @click="deleteTask">Delete</ui-dropdown-item>
                    </template>
                </ui-dropdown>
            </div>
        </div>

        <!-- Task Items. -->
        <draggable :list="task.items" draggable=".draggable" handle=".handle" group="items" @change="(update)?update():() =>{};">
            <inspection-test-plan-task-item v-for="(item,index) in task.items" :key="index" :item="item" :task="task"
                                            :inspection-test-plan="inspectionTestPlan"
                                            :editable="editable" :update="update"
                                            ref="items"></inspection-test-plan-task-item>
        </draggable>

        <!-- New Task Item. -->
        <div class="flex border-b mb-px border-gray-200" v-if="editable">
            <div class="w-6 flex-shrink-0 self-center">
                <i class="fa fa-plus text-xs text-gray-300"></i>
            </div>
            <div class="w-16 mr-px mt-px">
                <input
                    :placeholder="nextItemReference()"
                    class="text-sm -my-px px-2 py-1.5 border border-gray-200 shadow-none relative focus:z-10 hover:z-20"
                    type="text"
                    v-model="newItem.reference"
                >
            </div>
            <div class="flex-1 -m-px mt-px">
                <input
                    placeholder="Add a new item..."
                    class="text-sm -mx-px -my-px px-2 py-1.5 border border-gray-200 shadow-none relative focus:z-10"
                    type="text"
                    v-model="newItem.description"
                    @input="addItem"
                >
            </div>
            <div class="w-6 ml-2 mx-px"></div>
        </div>
        <div class="w-6 flex-shrink-0 ml-2"></div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import {InspectionTestPlan} from "../../models";
import {cloneDeep} from "lodash";

export default {
    components: {
        draggable
    },
    props: {
        inspectionTestPlan: InspectionTestPlan,
        section: Object,
        task: Object,
        editable: true,
        update: Function,
    },
    data() {
        return {
            newItem: {
                reference: null,
                description: null,
            },
            hasNonDefaultMarkup: false,
        }
    },
    methods: {
        addItem() {
            this.task.items.push({
                reference: this.newItem.reference ?? this.nextItemReference(),
                defaultReference: this.nextItemReference(),
                description: this.newItem.description,
                quantity: 0,
                uom: '',
                rate: 0,
                total: 0,
                materials: [],
                labour: [],
                fixedCosts: [],
            });
            this.$nextTick(() => {
                this.$refs.items[this.$refs.items.length - 1].$refs.description.focus()
                this.newItem.reference = null
                this.newItem.description = ''
            })
        },
        sumOfItemTotals() {
            return this.task.items.reduce((a, item) => a + item.total, 0)
        },
        sumOfItemRates() {
            return this.task.items.reduce((a, item) => a + item.rate, 0);
        },
        nextItemReference() {
            const sectionNumber = this.inspectionTestPlan.sections.indexOf(this.section) + 1;
            const taskNumber = this.section.tasks.indexOf(this.task) + 1;
            const itemNumber = this.task.items.length + 1
            return `${sectionNumber}.${taskNumber}.${itemNumber}`
        },
        deleteTask() {
            this.$modals.confirmDelete({
                title: `Delete task ${this.task.ref}`,
                button: 'Yes, delete task',
                handle: () => {
                    this.section.tasks = this.section.tasks.filter((task) => task !== this.task)
                    this.inspectionTestPlan.update()
                    this.inspectionTestPlan.addSnapshot()
                }
            })
        },
        duplicateTask() {
            this.section.tasks.splice(this.section.tasks.indexOf(this.task), 0, cloneDeep(this.task));
            this.inspectionTestPlan.update();
            this.inspectionTestPlan.addSnapshot()
        }
    },
}
</script>
